import { CenterContainer } from "./CenterText.styles";

interface ICenterTextProps {
  msg: string;
}

export const CenterText = ({ msg }: ICenterTextProps) => {
  return <CenterContainer>{msg}</CenterContainer>;
};
